<template>
  <div class="text-start my-3">
    <h2 class="bg-success text-white p-3 mx-3">
      برای شرکت در پروژه "۷ شهر زیست" تیمت رو تشکیل بده
    </h2>

    <div class="row p-3">
      <div class="col-md-6 col-12">
        <div class="p-3">
          - برای ساختن تیم خود ابتدا یک نام برای تیم انتخاب کنید و سپس دونفر از
          دوستان خود را به تیم اضافه نمایید.
        </div>
        <div class="p-3">
          - پس از وارد کردن شماره برای اعضا پیامک ارسال خواهد شد و آنها باید با
          همان شماره وارد سایت ستاوین شده و عضویت خود را تایید کنند.
          <br />
        </div>
        <div class="p-3">
          - پس از تشکیل تیم خود دیگر نمی توانید اعضای تیم را تغییر دهید ولی اگر
          به هر دلیلی لازم به تغییر اعضای تیم شد با پشتیبانی سایت 09045057103
          تماس بگیرید.
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="h_iframe-aparat_embed_frame">
          <span style="display: block; padding-top: 57%"></span
          ><iframe
            src="https://www.aparat.com/video/video/embed/videohash/av3fI/vt/frame"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          ></iframe>
        </div>
      </div>
    </div>
    <div class="container-fluid text-start">
      <div class="row mt-5">
        <div class="alert alert-danger" v-show="error">
          {{ error }}
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="نام گروه"
              v-model="teamName"
            />
            <label for="password">نام گروه *</label>
          </div>
        </div>

        <div class="col-md-4 col-xs-12">
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="تلفن همراه عضو یک"
              v-model="member1"
            />
            <label for="password">تلفن همراه عضو یک *</label>
          </div>
        </div>

        <div class="col-md-4 col-xs-12">
          <div class="form-floating mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="تلفن همراه عضو دو"
              v-model="member2"
            />
            <label for="password_confirmation">تلفن همراه عضو دو *</label>
          </div>
        </div>

        <div class="col-md-12 col-xs-12">
          <button
            :disabled="loading"
            class="btn btn-primary btn-block"
            @click="createTeam()"
          >
            ایجاد گروه و ارسال دعوت نامه برای اعضا
          </button>
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArefApi from "../../../../libs/api";
import utils from "../../../../libs/utils";
export default {
  emits: {
    reloadPage: Function,
  },
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
  },
  data() {
    return {
      error: null,
      showSaveBtn: true,
      teamName: null,
      member1: null,
      member2: null,
      teamId: null,
      loading: false,
    };
  },
  methods: {
    createTeam() {
      if (!this.valodation()) {
        return;
      }
      this.loading = true;
      this.arefApi
        .addTeam({ name: this.teamName })
        .then(async (res) => {
          this.teamId = res.id;
          await this.addMember(this.member1);
          await this.addMember(this.member2);
          this.utils.showSuccess(this);
          this.$emit("reloadPage");
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addMember(mobile) {
      return new Promise((resolve, reject) => {
        this.arefApi
          .addTeamMembers({ mobile })
          .then((res) => {
            return resolve(res);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },

    valodation() {
      this.error = null;
      if (!this.teamName || this.teamName.length < 3) {
        this.error = "نام تیم باید بیشتر از سه حرف باشد";
        return false;
      }

      if (!this.member1 || !this.utils.validMobile(this.member1)) {
        this.error = "تلفن همراه عضو اول را صحیح وارد کنید";
        return false;
      }

      if (!this.member2 || !this.utils.validMobile(this.member2)) {
        this.error = "تلفن همراه عضو دوم را صحیح وارد کنید";
        return false;
      }

      return true;
    },
  },
};
</script>
<style>
.h_iframe-aparat_embed_frame {
  position: relative;
}
.h_iframe-aparat_embed_frame .ratio {
  display: block;
  width: 100%;
  height: auto;
}
.h_iframe-aparat_embed_frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>